import { render, staticRenderFns } from "./FormVistoriador.vue?vue&type=template&id=2cd64a3a"
import script from "./FormVistoriador.vue?vue&type=script&lang=js"
export * from "./FormVistoriador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports